import { API } from './resources'

export default {
  createContact: (data) => {
    return API.post('/users/createContact', data)
  }
}
